// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var At = function At(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#at-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 1.875A8.124 8.124 0 0 0 1.875 10 8.124 8.124 0 0 0 10 18.125c.52 0 .938.418.938.938 0 .519-.418.937-.938.937-5.523 0-10-4.477-10-10S4.477 0 10 0s10 4.477 10 10v1.094a3.594 3.594 0 0 1-6.535 2.062A4.686 4.686 0 0 1 5.313 10a4.686 4.686 0 0 1 7.648-3.633.94.94 0 0 1 1.726.508v4.219a1.719 1.719 0 0 0 3.438 0V10A8.124 8.124 0 0 0 10 1.875M12.813 10a2.812 2.812 0 1 0-5.625 0 2.812 2.812 0 0 0 5.625 0"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "at-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
